module.exports = __webpack_public_path__ + "static/media/aluxion-white.b41a0da7.svg";